import Segmented from './segmented';
export default Segmented;
